module.exports = "/assets/hero-kropla@2x.png?9SF7wj7";